export function clamp(v: number, lo: number, hi: number): number {
  return v < lo ? lo : v > hi ? hi : v;
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function smoothstep(e0: number, e1: number, x: number): number {
  const t = clamp((x - e0) / (e1 - e0), 0, 1);
  return t * t * (3 - 2 * t);
}

export function damp(current: number, target: number, responseTime: number, dt: number): number {
  if (responseTime <= 0) return target;
  const factor = 1 - Math.exp((-dt * Math.LN2) / responseTime);
  return current + (target - current) * factor;
}

export function easeInOutCubic(t: number): number {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

export function wrapAngle(a: number): number {
  const TWO_PI = 2 * Math.PI;
  let result = a % TWO_PI;
  if (result > Math.PI) result -= TWO_PI;
  if (result < -Math.PI) result += TWO_PI;
  return result;
}
